module.exports = __webpack_public_path__ + "static/heroImage-3b42a93cd2dfdbf7bb7d25ea90512e98.svg";